export * from './classNames/index';
export * from './styles/index';
export * from './utilities/index';
export * from './MergeStyles';
import './version';
// Ensure theme is initialized when this package is referenced.
import { initializeThemeInCustomizations } from './styles/theme';
initializeThemeInCustomizations();
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@uifabric/styling/lib/index.js
// module id = 6
// module chunks = 0